export default "__VITE_ASSET__6ee8d848__"